// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__1qOXQ","title":"AfterBackImages_title__2kL8u","images":"AfterBackImages_images__1VQoU"};